import { t } from "i18next";
import Tabs from "../../../../components/elements/Tabs";
import EventsList from "../../../../components/sections/front/wishlist/EventsList";
import OrganizationList from "../../../../components/sections/front/wishlist/OrganizationList";

const WishList = () => {
  const tabItems = [
    {
      label: t("Events"),
      icon: "fa-regular fa-grid",
      content: <EventsList />,
    },
    {
      label: t("Organizations"),
      icon: "fa-regular fa-chart-line",
      content: <OrganizationList />,
    },
  ];

  return (
    <section className="relative py-24 bg-magnolia">
      <div className="max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl w-full mx-auto relative space-y-10">
        <Tabs
          items={tabItems}
          contentClass={"w-full"}
          tabsClass="gap-3 p-5 flex items-center gap-4 rounded-lg border-t border-slate-100"
          tabClass={
            "h-11 rounded-full bg-transparent border border-gray-200 flex items-center justify-center !text-deep-purple p-5 text-base capitalize font-normal"
          }
          activeTabClass={"bg-primary border border-primary !text-white"}
        />
      </div>
    </section>
  );
};

export default WishList;
